import api from './api';

export const getWorkPlans = (params) => api.get('/v1/work-plans', { params });
export const getWorkPlan = (id) => api.get(`/v1/work-plans/${id}`);
export const createWorkPlan = (data) => api.post('/v1/work-plans', data);
export const updateWorkPlan = (id, data) => api.put(`/v1/work-plans/${id}`, data);
export const deleteWorkPlan = (id) => api.delete(`/v1/work-plans/${id}`);
export const batchDeleteWorkPlans = (ids) => api.post('/v1/work-plans/batch-delete', ids);
export const getWorkPlanUsers = (id) => api.get(`/v1/work-plans/${id}/users`);
export const assignWorkPlanUsers = (id, data) => api.post(`/v1/work-plans/${id}/assign`, data);
export const removeWorkPlanUser = (id, userId) => api.delete(`/v1/work-plans/${id}/users/${userId}`);
